import React from "react";
import PropTypes from "prop-types";
import { CheckboxField } from "cxa-form-field";
import { Button } from "cxa-components";
import moment from "moment";
import HeaderForm from "../common/HeaderForm";
import { validateRequired } from "../validation";
import Part1 from "./Part1";
import Part2 from "./Part2";
import Part3 from "./Part3";
import Part4 from "./Part4";
import Part5 from "./Part5";
import Part6 from "./Part6";

export const SUBMIT_FAILURE_MESSAGE =
  "The form failed to submit. Please ensure you have completed all required fields as marked.";

const Form = ({ data, isReadOnly, onClose, onPrint, onSave, submitting, submitFailed }) => (
  <div style={{ padding: "10px 20px 10px 10px" }}>
    <HeaderForm />
    <Part1 data={data} />
    <Part2 data={data} />
    <Part3 data={data} />
    <Part4 data={data} />
    <Part5 data={data} />
    <Part6 data={data} />
    <br />
    <div>
      <span style={{ fontWeight: "bold" }}>DECLARATION: </span>I hereby declare that, to the best of
      my knowledge and belief the statements and answers given in this health declaration are true,
      complete and that I have not withheld any material facts, that is, facts likely to influence
      the assessment and acceptance of this application. I understand that any misstatement of fact,
      whether by commission or omission may be grounds for the Company in its absolute and sole
      discretion to decline to pay any benefit which may otherwise have been payable. I agree that
      this application, together with any additional statements signed by me which shall be deemed
      to be part of this declaration, shall be the basis of the contract of the insurance.
      <br />
      <br />
      {[
        "I understand that my application will be subject to acceptance by the ",
        "Company, and that I and/or my Dependant(s) will not be insured under any ",
        "of the insurance plan(s) for which my or my Dependant(s)'s application is ",
        "subject to acceptance until the Company advises the Policyholder the terms ",
        "and conditions on accepting insurance on myself and/or my Dependant(s), ",
        "and that the Company reserves the right to decline insurance or impose ",
        "special terms and conditions.",
      ].join("")}
      <br />
      <br />I understand that:
      <br />
      <table>
        <tbody>
          <tr>
            <td>(a)</td>
            <td>
              {[
                "if my application for my and/or my Dependant(s)' insurance under ",
                "any of the above plan(s) is accepted, my and/or Dependant(s)' ",
                "insurance under the plan shall terminate if the Policyholder does ",
                "not renew the plan before the expiry of any period of insurance, ",
                "or cancel the plan, or if I and/or my Dependant(s) attain the age ",
                "at which I and/or my Dependant(s)' insurance terminates as ",
                "specified in the terms and conditions of the insurance plan, and",
              ].join("")}
            </td>
          </tr>
          <tr>
            <td>(b)</td>
            <td>
              these plan(s) are yearly renewable and that the terms and conditions of the insurance
              plan(s) I and/or my Dependant(s) are insured under, including the premiums payable, at
              any renewal of the plan(s), may change upon agreement between the Policyholder and the
              Company.
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <p>I confirmed to have read and understood the contents of the following documents:</p>
      <table>
        <tbody>
          <tr>
            <td>(a)</td>
            <td>
              Your Guide to Health Insurance (you can download from
              www.lia.org.sg/consumers/library/consumers_guides)
            </td>
          </tr>
          <tr>
            <td>(b)</td>
            <td>Product Summary for voluntary plan</td>
          </tr>
        </tbody>
      </table>
      <br />
      <span style={{ color: "#f00" }}>
        I further agree that this form may be submitted to the Company by facsimile, electronic mail
        or other electronic means, including via a website or electronic portal designated by the
        Company. A copy of this form received via any of the above means may be stored
        electronically or using other means by or as authorized by the Company and the Company shall
        be entitled to rely on such copy, which shall have the same legal effect and validity as if
        were the original.
      </span>
      <br />
      <br />
      <span style={{ color: "#f00" }}>
        <span style={{ fontWeight: "bold" }}>AUTHORISATION: I, </span>
        {[
          "the undersigned, authorise any medical source, insurance ",
          "office/organisation or the Life Insurance Association's medical registry ",
          "to release any medical record or knowledge about me and/or my ",
          "Dependant(s) to the Company for risk assessment of my Group Insurance ",
          "Application.",
        ].join("")}
        <br />
        {[
          "I further consent to, and agree to procure my Dependant(s) to agree and ",
          "consent, the Company in releasing any information declared in my and/or ",
          "my dependant(s)' Personal Health Declaration Form / Personal Statement ",
          "and/or information revealed in my and/or my Dependant(s)' ",
          "questionnaires, medical reports and laboratory reports to my employer or ",
          "the administrator and/or the appointed insurance intermediary servicing ",
          "this Group Insurance Policy. A photocopy of this authorisation shall be ",
          "as effective and valid as the original.",
        ].join("")}
      </span>
      <br />
      <br />
      <span style={{ fontWeight: "bold" }}>PERSONAL DATA: </span>
      {[
        "By providing the information set out above, I agree and consent, and agree ",
        'to procure my dependant(s) to agree and consent, to the "Company", its ',
        'related corporations (collectively, the "Companies"), as well as their ',
        'respective representatives and agents ("Representatives") collecting, ',
        "using, disclosing and sharing amongst themselves my or my Dependant(s)'s ",
        "personal data, and disclosing such personal data to the Companies' ",
        "authorised service providers and relevant third parties for purposes ",
        "reasonably required by the Companies to evaluate my proposal and to ",
        "provide the relevant products or services which I am applying or have ",
        "applied for (including, without limitation, any policy renewals and policy ",
        "upgrades, substitutions or replacements).",
      ].join("")}
      <br />
      <br />
      {[
        "These purposes are set out in Great Eastern's Privacy Statement, which is ",
        "accessible at http://www.greateasternlife.com/sg/en/privacy-and-security-policy.html and ",
        "which I confirm I have read and understood.",
      ].join("")}
    </div>
    <br />
    <br />
    <CheckboxField
      {...(isReadOnly ? { disabled: { isReadOnly }, checked: { isReadOnly } } : {})}
      validate={validateRequired}
      name="declaration"
      id="declaration"
    >
      <strong>I have read and accept this declaration</strong>
    </CheckboxField>
    <br />
    <br />
    <table style={{ width: "100%" }}>
      <tbody>
        <tr>
          <td style={{ fontWeight: "bold", width: 50 }}>Date: </td>
          <td style={{ borderBottom: "1px solid #000", width: 280 }} id="RO_CompletedOn">
            {data["CompletedOn"] &&
              data["CompletedOn"].fieldValue &&
              moment(data["CompletedOn"].fieldValue).format()}
          </td>
          <td>&nbsp;</td>
          <td />
        </tr>
        <tr>
          <td>&nbsp;</td>
          <td>
            <div style={{ fontWeight: "bold" }}>Day/Month/Year</div>
            (Current Date of Completion of this form)
          </td>
          <td>&nbsp;</td>
        </tr>
      </tbody>
    </table>
    <br />
    <br />
    <table style={{ width: "100%" }}>
      <tbody>
        <tr>
          <td>
            <span style={{ fontWeight: "bold" }}>
              The Great Eastern Life Assurance Company Limited
            </span>{" "}
            (Reg. No. 1908 00011G)
            <br />
            Mailing Address: 1 Pickering Street, #10-01 Great Eastern Centre Singapore 048659
            <br />
            Tel +65 6248 0000&nbsp;&nbsp;&nbsp;&nbsp;Fax +65 6532
            3478&nbsp;&nbsp;&nbsp;&nbsp;Website www.greateasternlife.com
          </td>
          <td style={{ textAlign: "right", textDecoration: "underline" }}>GID/UWG/PHD/201808</td>
        </tr>
      </tbody>
    </table>
    {submitFailed && (
      <p role="alert" className="card--alert" style={{ marginTop: 20 }}>
        {SUBMIT_FAILURE_MESSAGE}
      </p>
    )}
    <div className="form__actions" style={{ marginTop: 10 }}>
      {!isReadOnly ? (
        [
          <Button key="save" type="button" onClick={onSave} disabled={submitting} secondary>
            Save
          </Button>,
          <Button primary key="submit" type="submit" submitting={submitting} disabled={submitting}>
            Submit & Confirm
          </Button>,
        ]
      ) : (
        <Button primary type="button" onClick={onPrint}>
          Print
        </Button>
      )}

      <Button onClick={onClose} type="button" disabled={submitting} secondary>
        Close
      </Button>
    </div>
  </div>
);

Form.propTypes = {
  confirm: PropTypes.func,
  onSave: PropTypes.func,
  submitFailed: PropTypes.bool.isRequired,
  data: PropTypes.shape({}),
  isReadOnly: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onPrint: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  submitSucceeded: PropTypes.bool,
};

export default Form;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Ge/GEHD201808/index.js